import React from 'react';
import { Typography, useTheme } from '@mui/material';

const DSTitleTypography = (props: React.ComponentProps<typeof Typography>) => {
  const { palette } = useTheme();
  return <Typography variant="h6" color={palette.text.primary} {...props} />;
};

export default DSTitleTypography;
